module.exports = __webpack_public_path__ + "5bfb840ce7e0f7204f6d4e849947f4fb.png";